import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';
import InProcessTasksList from './InProcessTasksList';

export default ColumnsContent(InProcessTasksList);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/InProcessTasksList/index.js